import {FEATURE_FLAG} from '@generated-backend-types';
import { Injectable, inject } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {ActivatedRouteSnapshot} from '@angular/router';
import {UserSessionService} from '../services/user-session-service/user-session.service';

@Injectable({providedIn: 'root'})
export class FeatureFlagGuard {
  private readonly userSessionService = inject(UserSessionService);
  private readonly toastr = inject(ToastrService);
  private readonly translateService = inject(TranslateService);


  public canActivate(route: ActivatedRouteSnapshot) {

    const allFeatureFlagsNeeded: FEATURE_FLAG[] | undefined = route.data['allFeatureFlagsNeeded'];
    const anyFeatureFlagNeeded: FEATURE_FLAG[] | undefined = route.data['anyFeatureFlagNeeded'];
    const showToastIfFeatureFlagMissing: boolean | undefined = route.data['showToastIfFeatureFlagMissing'] ?? true;

    let can = this.userSessionService.hasAllFeatureFlag(allFeatureFlagsNeeded ?? [])
    if (!can && showToastIfFeatureFlagMissing) {
      this.toastr.warning(this.translateService.instant('shared.feature_flags.missing_feature_flag', {missingFeatureFlags: allFeatureFlagsNeeded}));
    }

    if (can && anyFeatureFlagNeeded && anyFeatureFlagNeeded.length > 0) {
      can = this.userSessionService.hasAnyFeatureFlag(anyFeatureFlagNeeded)
    }
    return can
  }
}
